const key = (puzzle: number): string => `where-web-${puzzle}`;

/** localStorage, or undefined where it's blocked (private mode, sandboxed frames). */
export function safeStorage(): Storage | undefined {
  try {
    return globalThis.localStorage;
  } catch {
    return undefined;
  }
}

export function loadGuesses(storage: Storage | undefined, puzzle: number): string[] {
  try {
    const raw = storage?.getItem(key(puzzle));
    if (!raw) return [];
    const parsed = JSON.parse(raw) as { guesses?: unknown };
    return Array.isArray(parsed.guesses)
      ? parsed.guesses.filter((g): g is string => typeof g === "string")
      : [];
  } catch {
    return [];
  }
}

export function saveGuesses(storage: Storage | undefined, puzzle: number, guesses: string[]): void {
  try {
    storage?.setItem(key(puzzle), JSON.stringify({ guesses }));
  } catch {
    // Storage full or blocked: the game still plays, it just won't survive a reload.
  }
}
